import { useContext } from 'react';
import { GlobalLoaderContext } from '../context/GlobalLoaderContext';

export default function useLoader() {
  return useContext(GlobalLoaderContext);
}
